import { ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { toast } from '@ibinder/ui-common-core';

export const authLink = () =>
  new ApolloLink((operation, forward) => {
    const tenantId = localStorage.getItem('tenantId');

    // Add query names here if you want to ignore sending tenantId in request header
    const operationsToIgnoreTenantId = [
      'getOrgs',
      'postOrg',
      'getUsers',
      'getUserResourceAccess'
    ];

    let tenantHeader =
      tenantId &&
      operation.operationName !==
        operationsToIgnoreTenantId.find(
          (item) => item === operation.operationName
        )
        ? { 'x-ibinder-tenantid': tenantId }
        : {};

    operation.setContext({
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`,
        ...tenantHeader,
        ...operation.getContext().headers
      }
    });

    if (tenantId === undefined || tenantId === null) return forward(operation);

    // TODO: Replace with new function and move to commonUtils
    const tenantIdIsValidGuid =
      tenantId &&
      tenantId.match(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
      );

    if (tenantId && tenantIdIsValidGuid) {
      return forward(operation);
    }
  });

export const linkError = onError(({ networkError, operation, forward }) => {
  if (networkError?.message?.includes('Received status code 401')) {
    console.debug('Silent renew must have failed, trying signin redirect');
    window.location.replace(
      `/auth/signin-redirect?path=${
        window.location.pathname + window.location.search
      }`
    );
    //TODO: Om ovan inte fungerar - så måste vi EVENTUELLT börja med en silentsignin, men sannolikt behövs det inte.
  }
  toast.error(JSON.stringify(networkError));
});
